var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'card',
    { card_flipped: _vm.cardData.isFlipped, card_matched: _vm.cardData.isMatched },
  ]},[_c('div',{staticClass:"card__back"}),_c('img',{staticClass:"card__front",attrs:{"src":_vm.getImgUrl(`${_vm.cardData.name}.png`),"alt":_vm.cardData.img}})])
}
var staticRenderFns = []

export { render, staticRenderFns }